import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Users, UserPlus, ClipboardCheck, Radar, Settings, LogOut, MapPin } from 'lucide-react';
import { useAdminAuth } from '../../context/AdminAuthContext';
import { ADMIN_LAYOUT } from '../../constants/testIds';

const navItems = [
  { to: '/admin', label: 'Overview', icon: LayoutDashboard, testId: ADMIN_LAYOUT.navOverview, end: true },
  { to: '/admin/clients', label: 'Clients', icon: Users, testId: ADMIN_LAYOUT.navClients },
  { to: '/admin/clients/new', label: 'Add client', icon: UserPlus, testId: ADMIN_LAYOUT.navAddClient },
  { to: '/admin/approvals', label: 'Approval queue', icon: ClipboardCheck, testId: ADMIN_LAYOUT.navApprovals },
  { to: '/admin/audits', label: 'Audit history', icon: Radar, testId: ADMIN_LAYOUT.navAudits },
  { to: '/admin/settings', label: 'Settings', icon: Settings, testId: ADMIN_LAYOUT.navSettings },
];

const AdminLayout = () => {
  const { admin, logout } = useAdminAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-stone-100 flex">
      <aside data-testid={ADMIN_LAYOUT.sidebar} className="w-64 bg-stone-950 flex flex-col shrink-0">
        <div className="flex items-center gap-2 px-6 py-6 border-b border-stone-800">
          <span className="w-8 h-8 rounded-lg bg-[#F97316] flex items-center justify-center">
            <MapPin size={16} className="text-white" strokeWidth={2.5} />
          </span>
          <span className="text-lg font-extrabold text-white" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
            Ambanji
          </span>
        </div>

        <nav className="flex-1 px-3 py-5 space-y-1">
          {navItems.map(({ to, label, icon: Icon, testId, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={testId}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3.5 py-2.5 rounded-lg text-sm font-medium transition ${
                  isActive ? 'bg-[#F97316] text-white' : 'text-stone-400 hover:bg-stone-900 hover:text-stone-200'
                }`
              }
            >
              <Icon size={17} strokeWidth={2} />
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="px-3 py-4 border-t border-stone-800">
          <div className="px-3 pb-3 text-xs text-stone-500 truncate">{admin?.email}</div>
          <button
            data-testid={ADMIN_LAYOUT.logoutButton}
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-3.5 py-2.5 rounded-lg text-sm font-medium text-stone-400 hover:bg-stone-900 hover:text-red-400 transition"
          >
            <LogOut size={17} strokeWidth={2} />
            Log out
          </button>
        </div>
      </aside>

      <main className="flex-1 min-w-0 p-8">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
